export const LENDER_ZIP_MAP = {
  GPO_FCU: [
    12025,
    12032,
    12078,
    12095,
    12010,
    12086,
    12117,
    13452,
    13470,
    12108,
    12139,
    12164,
    12190,
    12847,
    12864,
    13324,
    13329,
    13350,
    13357,
    13365,
    13406,
    13407,
    13416,
    13431,
    13454,
    13472,
    13475,
    13491,
    13032,
    13035,
    13037,
    13043,
    13052,
    13061,
    13082,
    13122,
    13134,
    13163,
    13310,
    13314,
    13355,
    13364,
    13402,
    13408,
    13418,
    13421,
    13465,
    13484,
    12016,
    12066,
    12068,
    12069,
    12070,
    12072,
    12166,
    12177,
    13317,
    13339,
    13410,
    13428,
    13301,
    13308,
    13312,
    13313,
    13318,
    13319,
    13321,
    13322,
    13323,
    13327,
    13328,
    13335,
    13338,
    13341,
    13342,
    13352,
    13354,
    13401,
    13403,
    13413,
    13417,
    13424,
    13425,
    13435,
    13455,
    13461,
    13469,
    13476,
    13477,
    13478,
    13479,
    13480,
    12064,
    12116,
    12155,
    12197,
    13315,
    13320,
    13326,
    13333,
    13337,
    13348,
    13415,
    13439,
    13450,
    13457,
    13468,
    13482,
    13488,
    '12010',
    '12016',
    '12066',
    '12068',
    '12069',
    '12070',
    '12072',
    '13032',
    '13035',
    '13037',
    '13043',
    '13052',
    '13061',
    '13082',
    '13122',
    '13134',
    '13163',
    '13310',
    '13314',
    '13355',
    '13364',
    '13402',
    '13408',
    '13418',
    '13421',
    '13465',
    '13484',
    '13324',
    '13329',
    '13350',
    '13357',
    '13365',
    '13406',
    '13407',
    '13416',
    '13431',
    '13454',
    '13472',
    '13475',
    '13491',
    '12025',
    '12032',
    '12078',
    '12095',
    '12086',
    '12117',
    '13452',
    '13470',
  ],
  SUMMIT_FCU: [
    13040,
    13045,
    13056,
    13077,
    13087,
    13101,
    13141,
    13158,
    13738,
    13803,
    13863,
    14201,
    14202,
    14203,
    14204,
    14205,
    14206,
    14207,
    14208,
    14209,
    14210,
    14211,
    14212,
    14213,
    14214,
    14215,
    14216,
    14217,
    14218,
    14219,
    14220,
    14221,
    14222,
    14223,
    14224,
    14225,
    14226,
    14227,
    14228,
    14231,
    14233,
    14240,
    14241,
    14260,
    14261,
    14263,
    14264,
    14265,
    14267,
    14269,
    14270,
    14272,
    14273,
    14276,
    14280,
    13201,
    13202,
    13203,
    13204,
    13205,
    13206,
    13207,
    13208,
    13209,
    13210,
    13211,
    13212,
    13214,
    13215,
    13217,
    13218,
    13219,
    13220,
    13221,
    13224,
    13225,
    13235,
    13244,
    13250,
    13251,
    13252,
    13261,
    13290,
    '14450',
    '14464',
    14467,
    14468,
    14506,
    14511,
    14515,
    14526,
    14604,
    14605,
    14606,
    14607,
    14608,
    14609,
    14610,
    14611,
    14612,
    14613,
    14614,
    14615,
    14616,
    14617,
    14618,
    14619,
    14620,
    14621,
    14622,
    14623,
    14624,
    14625,
    14626,
    14627,
    14642,
    14647,
    14150,
    14151,
    14217,
    14223,
    '14068',
    '14221',
    14226,
    14228,
    14231,
    14260,
    14261,
    '14068',
    '14221',
    '14226',
    '14228',
    '14231',
    14260,
    14261,
    14201,
    14202,
    14203,
    14204,
    14205,
    14206,
    14207,
    14208,
    14209,
    14210,
    14211,
    14212,
    14213,
    14214,
    14215,
    14216,
    14217,
    14218,
    14219,
    14220,
    14222,
    14223,
    14224,
    14225,
    14227,
    14233,
    14240,
    14241,
    14263,
    14264,
    14265,
    14267,
    14269,
    14270,
    14272,
    14273,
    14276,
    14280,
    13040,
    13045,
    13056,
    13077,
    13087,
    13101,
    13141,
    13158,
    13738,
    13803,
    13863,
    14456,
    14450,
    14464,
    14467,
    14468,
    14506,
    14511,
    14515,
    14526,
    14604,
    14605,
    14606,
    14607,
    14608,
    14609,
    14610,
    14611,
    14612,
    14613,
    14614,
    14615,
    14616,
    14617,
    14618,
    14619,
    14620,
    14621,
    14622,
    14623,
    14624,
    14625,
    14626,
    14627,
    14642,
    14647,
    13201,
    13202,
    13203,
    13204,
    13205,
    13206,
    13207,
    13208,
    13209,
    13210,
    13211,
    13212,
    13214,
    13215,
    13217,
    13218,
    13219,
    13220,
    13221,
    13224,
    13225,
    13235,
    13244,
    13250,
    13251,
    13252,
    13261,
    13290,
    14150,
    14151,
  ],
  BROADVIEW_FCU: [
    12010,
    12025,
    12082,
    12118,
    13452,
    13468,
    13326,
    13335,
    13348,
    13415,
    13439,
    13450,
    13457,
    13468,
    13482,
    13488,
    14226,
    14228,
    14260,
    14261,
    14012,
    13734,
    '13736',
    '13737',
    13901,
    13903,
    13904,
    13905,
    13906,
    13907,
    14201,
    14202,
    14203,
    14204,
    14205,
    14206,
    14207,
    14208,
    14209,
    14210,
    14211,
    14212,
    14213,
    14214,
    14215,
    14216,
    14217,
    14218,
    14219,
    14220,
    14221,
    14222,
    14223,
    14224,
    14225,
    14226,
    14227,
    14228,
    14231,
    13743,
    13812,
    '12047',
    '12019',
    '12147',
    13754,
    13748,
    13905,
    12183,
    13795,
    13792,
    13797,
    12301,
    12302,
    12303,
    12304,
    12305,
    12306,
    12307,
    12308,
    12309,
    13201,
    13202,
    13203,
    13204,
    13205,
    13206,
    13207,
    13208,
    13209,
    13210,
    13211,
    13212,
    13214,
    13215,
    12201,
    12202,
    12203,
    12204,
    12205,
    12206,
    12207,
    12208,
    12209,
    12210,
    12211,
    12212,
    12220,
    12222,
    12223,
    12224,
    12225,
    12226,
    12227,
    12228,
    12229,
    12230,
    12231,
    12232,
    12233,
    12234,
    12235,
    12236,
    12237,
    12238,
    14226,
    14228,
    14260,
    14261,
    14012,
    13734,
    13736,
    13737,
    13901,
    13903,
    13904,
    13905,
    13906,
    13907,
    14201,
    14202,
    14203,
    14204,
    14205,
    14206,
    14207,
    14208,
    14209,
    14210,
    14211,
    14212,
    14213,
    14214,
    14215,
    14216,
    14217,
    14218,
    14219,
    14220,
    14221,
    14222,
    14223,
    14224,
    14225,
    14227,
    14231,
    13743,
    13812,
    12047,
    12019,
    12147,
    13754,
    13748,
    12183,
    13795,
    13792,
    13797,
    12118,
    12179,
    12010,
    12025,
    12082,
    13452,
    13468,
    13807,
    13326,
    13335,
    13348,
    13415,
    13439,
    13450,
    13457,
    13482,
    13488,
    12144,
    12143,
    12122,
    13835,
    12301,
    12302,
    12303,
    12304,
    12305,
    12306,
    12307,
    12308,
    12309,
    14883,
    14884,
    13201,
    13202,
    13203,
    13204,
    13205,
    13206,
    13207,
    13208,
    13209,
    13210,
    13211,
    13212,
    13214,
    13215,
    13814,
    12180,
    12181,
    12182,
    12189,
    13456,
    13459,
  ],
  QUORUM_FCU: [
    // Broadview
    14204, 14205, 14206, 14207, 14208, 14209, 14210, 14211, 14212, 14213, 14214, 14215, 14216,
    14217, 14218, 14219, 14220, 14221, 14222, 14223, 14224,
  ],
};

export const utm_email_type = {
  AUTO_NEW_ECONOMY: {
    make: 'Toyota',
    model: 'Camry',
    vehicle_year: '2026',
    mileage: 100,
    auto_type: 'Sedan',
    estimateValue: 30000,
    downPayment: 8000,
    loan_type: 'Auto',
    loanAmount: 22000,
    loanTerms: [36, 48, 60, 72],
    selectedLoanTerms: { 36: 36, 48: 48, 60: 60, 72: 72 },
  },
  AUTO_NEWLY_USED_ECONOMY: {
    make: 'Toyota',
    model: 'Camry',
    vehicle_year: '2022',
    mileage: 15000,
    auto_type: 'Sedan',
    estimateValue: 22000,
    downPayment: 5000,
    loan_type: 'Auto',
    loanAmount: 17000,
    loanTerms: [36, 48, 60, 72],
    selectedLoanTerms: { 36: 36, 48: 48, 60: 60, 72: 72 },
  },
  AUTO_USED_ECONOMY: {
    make: 'Toyota',
    model: 'Camry',
    vehicle_year: '2019',
    mileage: 40000,
    auto_type: 'Sedan',
    estimateValue: 11000,
    downPayment: 3000,
    loan_type: 'Auto',
    loanAmount: 8000,
    loanTerms: [36, 48, 60, 72],
    selectedLoanTerms: { 36: 36, 48: 48, 60: 60, 72: 72 },
  },
  AUTO_NEW_SUV: {
    make: 'Nissan',
    model: 'Rogue',
    vehicle_year: '2026',
    mileage: 100,
    auto_type: 'SUV',
    estimateValue: 35000,
    downPayment: 10000,
    loan_type: 'Auto',
    loanAmount: 25000,
    loanTerms: [36, 48, 60, 72],
    selectedLoanTerms: { 36: 36, 48: 48, 60: 60, 72: 72 },
  },
  AUTO_NEWLY_USED_SUV: {
    make: 'Nissan',
    model: 'Rogue',
    vehicle_year: '2022',
    mileage: 15000,
    auto_type: 'SUV',
    estimateValue: 23000,
    downPayment: 8000,
    loan_type: 'Auto',
    loanAmount: 15000,
    loanTerms: [36, 48, 60, 72],
    selectedLoanTerms: { 36: 36, 48: 48, 60: 60, 72: 72 },
  },
  AUTO_USED_SUV: {
    make: 'Nissan',
    model: 'Rogue',
    vehicle_year: '2019',
    mileage: 40000,
    auto_type: 'SUV',
    estimateValue: 13000,
    downPayment: 4000,
    loan_type: 'Auto',
    loanAmount: 9000,
    loanTerms: [36, 48, 60, 72],
    selectedLoanTerms: { 36: 36, 48: 48, 60: 60, 72: 72 },
  },
  AUTO_NEW_LUXURY: {
    make: 'Mercedes-Benz',
    model: 'E-Class',
    vehicle_year: '2026',
    mileage: 100,
    auto_type: 'Sedan',
    estimateValue: 65000,
    downPayment: 19000,
    loan_type: 'Auto',
    loanAmount: 46000,
    loanTerms: [36, 48, 60, 72],
    selectedLoanTerms: { 36: 36, 48: 48, 60: 60, 72: 72 },
  },
  AUTO_NEWLY_USED_LUXURY: {
    make: 'Mercedes-Benz',
    model: 'E-Class',
    vehicle_year: '2022',
    mileage: 15000,
    auto_type: 'Sedan',
    estimateValue: 38000,
    downPayment: 10000,
    loan_type: 'Auto',
    loanAmount: 28000,
    loanTerms: [36, 48, 60, 72],
    selectedLoanTerms: { 36: 36, 48: 48, 60: 60, 72: 72 },
  },
  AUTO_USED_LUXURY: {
    make: 'Mercedes-Benz',
    model: 'E-Class',
    vehicle_year: '2019',
    mileage: 40000,
    auto_type: 'Sedan',
    estimateValue: 25000,
    downPayment: 9000,
    loan_type: 'Auto',
    loanAmount: 16000,
    loanTerms: [36, 48, 60, 72],
    selectedLoanTerms: { 36: 36, 48: 48, 60: 60, 72: 72 },
  },
  AUTO_NEW_TESLA: {
    make: 'Tesla',
    model: '3',
    vehicle_year: '2026',
    mileage: '100',
    auto_type: 'Sedan',
    estimateValue: 40000,
    downPayment: 9000,
    loan_type: 'Auto',
    loanAmount: 16000,
    loanTerms: [36, 48, 60, 72],
    selectedLoanTerms: { 36: 36, 48: 48, 60: 60, 72: 72 },
  },
  AUTO_NEWLY_USED_TESLA: {
    make: 'Tesla',
    model: '3',
    vehicle_year: '2022',
    mileage: 15000,
    auto_type: 'Sedan',
    estimateValue: 22000,
    downPayment: 8000,
    loan_type: 'Auto',
    loanAmount: 14000,
    loanTerms: [36, 48, 60, 72],
    selectedLoanTerms: { 36: 36, 48: 48, 60: 60, 72: 72 },
  },
  AUTO_USED_TESLA: {
    make: 'Tesla',
    model: '3',
    vehicle_year: '2019',
    mileage: 40000,
    auto_type: 'Sedan',
    estimateValue: 13000,
    downPayment: 4000,
    loan_type: 'Auto',
    loanAmount: 9000,
    loanTerms: [36, 48, 60, 72],
    selectedLoanTerms: { 36: 36, 48: 48, 60: 60, 72: 72 },
  },
  MORTGAGE_SINGLE_FAMILY_PRIMARY: {
    loan_amount: 300000,
    loanAmount: 300000,
    loan_type: 'Mortgage',
    occupancyType: 'Primary',
    propertyType: 'Single Family',
    estimateValue: 350000,
    down_payment: 50000,
    downPayment: 50000,
    mortgageLoanTermMonth: [240, 360],
    mortgageTermInYears: { 20: 20, 30: 30 },
    mortgageTerm: { 240: 20, 360: 30 },
  },
  MORTGAGE_SINGLE_FAMILY_SECONDARY: {
    loan_amount: 200000,
    loanAmount: 200000,
    loan_type: 'Mortgage',
    occupancyType: 'Secondary',
    propertyType: 'Single Family',
    estimateValue: 350000,
    down_payment: 50000,
    downPayment: 50000,
    mortgageLoanTermMonth: [240, 360],
    mortgageTermInYears: { 20: 20, 30: 30 },
    mortgageTerm: { 240: 20, 360: 30 },
  },
  MORTGAGE_SINGLE_FAMILY_INVESTMENT: {
    loan_amount: 350000,
    loanAmount: 350000,
    loan_type: 'Mortgage',
    occupancyType: 'Investment',
    propertyType: 'Single Family',
    estimateValue: 500000,
    down_payment: 150000,
    downPayment: 150000,
    mortgageLoanTermMonth: [240, 360],
    mortgageTermInYears: { 20: 20, 30: 30 },
    mortgageTerm: { 240: 20, 360: 30 },
  },
  MORTGAGE_CONDO_PRIMARY: {
    loan_amount: 200000,
    loanAmount: 200000,
    loan_type: 'Mortgage',
    occupancyType: 'Primary',
    propertyType: 'Condo',
    estimateValue: 240000,
    down_payment: 40000,
    downPayment: 40000,
    mortgageLoanTermMonth: [240, 360],
    mortgageTermInYears: { 20: 20, 30: 30 },
    mortgageTerm: { 240: 20, 360: 30 },
  },
  MORTGAGE_CONDO_SECONDARY: {
    loan_amount: 200000,
    loanAmount: 200000,
    loan_type: 'Mortgage',
    occupancyType: 'Secondary',
    propertyType: 'Condo',
    estimateValue: 240000,
    down_payment: 40000,
    downPayment: 40000,
    mortgageLoanTermMonth: [240, 360],
    mortgageTermInYears: { 20: 20, 30: 30 },
    mortgageTerm: { 240: 20, 360: 30 },
  },
  MORTGAGE_CONDO_INVESTMENT: {
    loan_amount: 200000,
    loanAmount: 200000,
    loan_type: 'Mortgage',
    occupancyType: 'Secondary',
    propertyType: 'Condo',
    estimateValue: 240000,
    down_payment: 40000,
    downPayment: 40000,
    mortgageLoanTermMonth: [240, 360],
    mortgageTermInYears: { 20: 20, 30: 30 },
    mortgageTerm: { 240: 20, 360: 30 },
  },
  MORTGAGE_MULTI_FAMILY_PRIMARY: {
    loan_amount: 500000,
    loanAmount: 500000,
    loan_type: 'Mortgage',
    occupancyType: 'Primary',
    propertyType: 'Multi Family',
    estimateValue: 600000,
    down_payment: 100000,
    downPayment: 100000,
    mortgageLoanTermMonth: [240, 360],
    mortgageTermInYears: { 20: 20, 30: 30 },
    mortgageTerm: { 240: 20, 360: 30 },
  },
  MORTGAGE_MULTI_FAMILY_INVESTMENT: {
    loan_amount: 500000,
    loanAmount: 500000,
    loan_type: 'Mortgage',
    occupancyType: 'Investment',
    propertyType: 'Multi Family',
    estimateValue: 600000,
    down_payment: 100000,
    downPayment: 100000,
    mortgageLoanTermMonth: [240, 360],
    mortgageTermInYears: { 20: 20, 30: 30 },
    mortgageTerm: { 240: 20, 360: 30 },
  },
};
